import { render } from "./ClassgroupStudentsCreate.vue?vue&type=template&id=d680dcc4&ts=true"
import script from "./ClassgroupStudentsCreate.vue?vue&type=script&lang=ts"
export * from "./ClassgroupStudentsCreate.vue?vue&type=script&lang=ts"

import "./ClassgroupStudentsCreate.vue?vue&type=style&index=0&id=d680dcc4&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__